import React, { useEffect, useState } from "react";
import { Button, CloseButton, Form } from "react-bootstrap";
import { ShareFooter } from "./ShareTray/ShareFooter";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import { X } from "react-bootstrap-icons";
import CheckStatus from "../lib/checkUserStatus";
import { UserAuth } from "../Context";

const InviteCollaborators = ({
  closeTray,
  inviteOption,
  setInviteOption,
  onEmailFinish,
  emailUsers,
  removeEmail,
  emailInputValue,
  handleEmailChange,
  handleKeyDown,
  content,
  setContent,
  handleSearchBar,
  input,
  setInput,
  setIsFriendsDataEmpty,
  searchLoading,
  selectedFriends,
  handleSelectFriend,
  friendsData,
  isFriendsDataEmpty,
  loading,
  handleCopyLink,
  handleFacebookShare,
  handleWhatsappShare,
  handleInvite,
  Error,
  members,
}) => {
  const { user } = UserAuth();
  const Option = (option, text) => {
    return (
      <div
        onClick={() => setInviteOption(option)}
        style={{
          cursor: "pointer",
          backgroundColor: inviteOption === option ? "#F4F9FF" : "white",
          height: "38px",
          padding: "4px 12px",
          color: inviteOption === option ? "#005FDA" : "black",
          borderRadius: "4px",
        }}
        className="d-flex align-items-center justify-content-center"
      >
        {text}
      </div>
    );
  };

  return (
    <>
      <div style={{ marginTop: "12px" }}>
        <div className="d-flex flex-column " style={{ gap: "12px" }}>
          <div
            className="d-flex align-items-center bg-white"
            style={{ gap: "20px", borderRadius: "8px", padding: "2px" }}
          >
            {Option("users", "Users")}
            {Option("email", "Email")}
          </div>
          <div className="d-flex flex-column " style={{ gap: "24px" }}>
            {inviteOption === "email" ? (
              <Form
                className="d-flex flex-column gap-1"
                onSubmit={async (e) => {
                  e.preventDefault();
                  onEmailFinish(emailUsers);
                }}
              >
                <div>
                  {emailUsers.length > 0 && (
                    <div
                      className="d-flex align-items-center gap-2 mb-2"
                      style={{
                        overflowX: "auto",
                        scrollbarWidth: "thin",
                        paddingBottom: "4px",
                      }}
                    >
                      {emailUsers.map((email, index) => (
                        <Button
                          key={index}
                          size="sm"
                          variant="primary-soft"
                          className="d-flex align-items-center"
                        >
                          {email}
                          <CloseButton
                            className="ms-2"
                            onClick={() => removeEmail(index)}
                          />
                        </Button>
                      ))}
                    </div>
                  )}
                  <div className="d-flex gap-2 align-items-center">
                    <Form.Control
                      type="text"
                      placeholder="email@example.com"
                      className="rounded-2 h-50"
                      value={emailInputValue}
                      onChange={handleEmailChange}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
                <span className="text-danger">{Error}</span>
                <div className="mt-0">
                  <textarea
                    className="form-control rounded-2"
                    rows="2"
                    placeholder="Add a note or message (Optional)"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    maxLength={300}
                  />
                  <small>Character limit: 300</small>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    className="rounded-3 w-100"
                    type="submit"
                    variant="primary"
                    disabled={
                      emailUsers.length === 0 && emailInputValue.length === 0
                    }
                  >
                    <span>Send Invite</span>
                  </Button>
                </div>
              </Form>
            ) : (
              <form onSubmit={(event) => handleSearchBar(event)}>
                <div className="input-group gap-2">
                  <input
                    type="text"
                    className="form-control rounded-3"
                    placeholder="Search by name or email"
                    value={input}
                    onChange={(e) => {
                      setInput(e.target.value);
                      setIsFriendsDataEmpty(false);
                    }}
                    required
                  />
                  <button
                    style={{ width: "6rem" }}
                    className="btn btn-primary rounded-3"
                    disabled={input.length < 3}
                    type="submit"
                  >
                    {searchLoading ? (
                      <LoadingSpinner height="10px" spinnerSize="20px" />
                    ) : (
                      "Search"
                    )}
                  </button>
                </div>
                {selectedFriends.length > 0 && (
                  <div
                    className="alphabet-list navbar thinScrollBar py-2"
                    style={{ overflowX: "auto" }}
                  >
                    <ul className="nav d-flex flex-row flex-nowrap list-unstyled gap-2 pt-1 ">
                      {selectedFriends.map((friend) => {
                        return (
                          <li
                            key={friend.objectID}
                            className="btn rounded-2 btn-sm btn-primary-soft  d-flex gap-2 align-items-center ps-1 py-1"
                            onClick={() =>
                              handleSelectFriend(friend.objectID, false, friend)
                            }
                          >
                            <X className="fs-5 " />

                            <div style={{ whiteSpace: "nowrap" }}>
                              {friend.displayName}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
                {/* <hr /> */}
                {friendsData?.length > 0 && (
                  <>
                    <div
                      className="d-flex flex-column mt-2"
                      style={{ maxHeight: "12rem", overflowY: "auto" }}
                    >
                      {friendsData?.map((friend, index) => {
                        return (
                          <div
                            key={friend.objectID}
                            className="d-flex justify-content-between align-items-center w-100 my-1"
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "6px" }}
                            >
                              <input
                                name="members"
                                type="checkbox"
                                className="form-check-input"
                                checked={!!members[friend.objectID]}
                                onChange={(e) =>
                                  handleSelectFriend(
                                    friend.objectID,
                                    e.target.checked,
                                    friend
                                  )
                                }
                              />
                              <img
                                src={
                                  friend?.objectUser?.photo ||
                                  `https://ui-avatars.com/api/?name=${friend?.objectUser?.userName[0]?.toUpperCase()}`
                                }
                                style={{
                                  borderRadius: "8px",
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                                loading="lazy"
                                alt=""
                              />
                              <div
                                className="d-flex flex-column"
                                style={{ gap: "2px" }}
                              >
                                <div
                                  style={{
                                    fontFamily: "Inter",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    lineHeight: "100%",
                                    letterSpacing: "0%",
                                    color: "black",
                                  }}
                                >
                                  {friend?.displayName}
                                </div>
                                <CheckStatus
                                  myUid={user?.uid}
                                  yourEmail={friend?.email}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
                {isFriendsDataEmpty && (
                  <div className="text-center pt-3">
                    <div className="h5 mb-0">No users found</div>
                  </div>
                )}
              </form>
            )}
            {friendsData?.length > 0 &&
              inviteOption === "users" &&
              (loading ? (
                <button
                  type="button"
                  className="btn btn-primary w-100 rounded-3"
                >
                  <LoadingSpinner spinnerSize="1rem" height="1.5rem" />
                </button>
              ) : (
                <button
                  onClick={() => handleInvite()}
                  type="button"
                  disabled={selectedFriends.length === 0}
                  className="btn btn-primary w-100 rounded-3"
                >
                  Send Invite
                </button>
              ))}
            <ShareFooter
              handleCopyLink={handleCopyLink}
              handleFacebookShare={handleFacebookShare}
              handleWhatsappShare={handleWhatsappShare}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default InviteCollaborators;
